const leaveWordStatusConstService = {
    leaveWordStatusList: [
        {
            statusEnName: "NOT_REPLY",
            statusCnName: "尚未回复"
        },
        {
            statusEnName: "ALREADY_REPLY",
            statusCnName: "已回复"
        }
    ],
    getCnNameByEnName(statusEnName) {
        return this.leaveWordStatusList.find(item => item.statusEnName === statusEnName).statusCnName;
    }

}
export default leaveWordStatusConstService